"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootApp = void 0;
require("rxjs");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var connected_react_router_1 = require("connected-react-router");
var store_1 = require("../store");
var sok_ui_1 = require("@caddigital/sok-ui");
var LoginView_1 = require("../views/LoginView");
var SSOView_1 = require("../views/SSOView");
var ForgotPasswordView_1 = require("../views/ForgotPasswordView");
var ResetPasswordView_1 = require("../views/ResetPasswordView");
var AuthorizingView_1 = require("../views/AuthorizingView");
var OAuth2_1 = require("../views/OAuth2");
var FirstLoginView_1 = require("../views/FirstLoginView");
var SSORedirect_1 = require("../views/SSORedirect");
var AppRouter_1 = require("./AppRouter");
if (__ENVIRONMENT__ === 'production') {
    store_1.history.listen(function (location) {
        if (window.gtag) {
            window.gtag('set', 'page', location.pathname + location.search);
            window.gtag('send', 'pageview');
        }
    });
}
var RootApp = function () {
    return (React.createElement(connected_react_router_1.ConnectedRouter, { history: store_1.history },
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/authorizing", render: function (props) { return React.createElement(AuthorizingView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/authorize", render: function (props) { return React.createElement(OAuth2_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/sso/:provider", render: function (props) { return React.createElement(SSORedirect_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/:language/login", render: function (props) { return React.createElement(LoginView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/:language/logout", render: function () { return (React.createElement("div", { style: {
                        display: 'flex',
                        height: '100%',
                        width: '100%',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } },
                    React.createElement(sok_ui_1.LoadingSpinner, null))); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/:language/sso", render: function (props) { return React.createElement(SSOView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/:language/forgotpassword", render: function (props) { return React.createElement(ForgotPasswordView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/:language/first-time", render: function (props) { return React.createElement(FirstLoginView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { path: "/:language/resetpassword", render: function (props) { return React.createElement(ResetPasswordView_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { path: '/:language?', render: function (props) { return React.createElement(AppRouter_1.default, __assign({}, props)); } }))));
};
exports.RootApp = RootApp;
